export class PenPipeSDRDto {
  public static ApiUrl = 'api/pen-pipe-SDR';

  Id: number;
  Name: string;
  SDR: number;
}

export class CheckDuplicatePenPipeSDR {
  Id?: number;
  SDR: number;
}
